import { Helmet } from 'react-helmet';

import { Header, SubHeader, Visible } from 'coreOld/components';

interface IProps {
  children?: React.ReactNode;
  title?: string;
  subTitle?: string | number | JSX.Element;
  hasHeader?: boolean;
  hasSubHeader?: boolean;
  isHeaderFixed?: boolean;
  hasSearchBar?: boolean;
  triggerSignInModal?: boolean;
  collapsedMenu?: boolean;
}

/* @deprecated */
const PageLayout = ({
  children,
  title,
  subTitle,
  hasHeader = true,
  hasSubHeader = true,
  isHeaderFixed = true,
  hasSearchBar = true,
  triggerSignInModal = false,
  collapsedMenu = false,
}: IProps) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      {hasHeader && (
        <Header
          isFixed={isHeaderFixed}
          hasSearchBar={hasSearchBar}
          triggerSignInModal={triggerSignInModal}
          collapsedMenu={collapsedMenu}
        />
      )}

      <Visible when={hasSubHeader}>
        <SubHeader isHeaderFixed={isHeaderFixed} text={title} subText={subTitle} />
      </Visible>

      {children}
    </>
  );
};

export default PageLayout;
